module.exports = __webpack_public_path__ + "img/view-one-pane.febaa0fa.svg";